import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
  TableHeaderBulkSelectCheckbox,
} from '@occc-app/design-system';
import { OpenCommerceUserFragment } from '@occc/graphql';
import {
  IPaginationProps,
  PaginationHandler,
  PaginationInfo,
} from '@occc-app/hooks/usePaginatedQuery';
import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';

import RetailerNetworkUsersListItem from './retailer-network-users-list-item.component';

type RetailerNetworkUsersListProps = ReturnType<typeof useBulkSelect> & {
  loading: boolean;
  error?: ApolloError;
  data?: OpenCommerceUserFragment[];
  paginationProps: IPaginationProps;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
};

const RetailerNetworkUsersList = ({
  loading,
  error,
  data,
  paginationProps,
  bulkSelectedItems,
  handleBulkSelectMultiple,
  handleItemSelect,
}: RetailerNetworkUsersListProps) => {
  const currentPageUserUuids = data?.map((item) => item.uuid) || [];

  const renderData = (items: OpenCommerceUserFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding='checkbox'>
              <TableHeaderBulkSelectCheckbox
                bulkSelectedItems={bulkSelectedItems}
                handleBulkSelectMultiple={handleBulkSelectMultiple}
                currentPageItems={currentPageUserUuids}
              />
            </TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Mobile Phone Number</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((user) => (
            <RetailerNetworkUsersListItem
              user={user}
              key={user.uuid}
              isItemSelected={bulkSelectedItems.has(user.uuid)}
              handleItemSelect={handleItemSelect}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<OpenCommerceUserFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};

export default RetailerNetworkUsersList;
